
import { Component, Prop, Vue } from 'vue-property-decorator'
import { DNSZonesInterface } from '@/services/DNS/Interfaces'

@Component
export default class DeleteDnsZoneDialog extends Vue {
  @Prop() private readonly zone!: DNSZonesInterface
  @Prop() private readonly onDelete!: CallableFunction

  private visible: boolean = true

  get message(): string {
    return `Are you sure you want to remove ${this.zone.installation.domain}?`
  }

  private destroyComponent(): void {
    this.$emit('close')
  }

  private async deleteZone(): Promise<void> {
    await this.onDelete(this.zone)
    this.destroyComponent()
  }
}
